import { __spreadArray, __read } from 'tslib';
import { UserAuthProvider } from '@invitae/cms-blocks';
import { combineProviders } from './combineProviders.esm.js';
import PageAnalyticsProvider from './providers/PageAnalyticsProvider/PageAnalyticsProvider.esm.js';
import AnimationProvider from './providers/AnimationProvider/AnimationProvider.esm.js';
import BaseComponentProvider from './providers/BaseComponentProvider/BaseComponentProvider.esm.js';
import BrowserProvider from './providers/BrowserProvider/BrowserProvider.esm.js';
import CartProvider from './providers/CartProvider/CartProvider.esm.js';
import ComponentBlockProvider from './providers/ComponentBlockProvider/ComponentBlockProvider.esm.js';
import ContentfulPreviewProvider from './providers/ContentfulPreviewProvider/ContentfulPreviewProvider.esm.js';
import ContentfulProvider from './providers/ContentfulProvider/ContentfulProvider.esm.js';
import CountryLocationProvider from './providers/CountryLocationProvider/CountryLocationProvider.esm.js';
import DimensionsProvider from './providers/DimensionsProvider/DimensionsProvider.esm.js';
import GlobalActionsProvider from './providers/GlobalActionsProvider/GlobalActionsProvider.esm.js';
import GlobalTextCopyProvider from './providers/GlobalTextCopyProvider/GlobalTextCopyProvider.esm.js';
import LocationProvider from './providers/LocationProvider/LocationProvider.esm.js';
import NavigationProvider from './providers/NavigationProvider/NavigationProvider.esm.js';
import NucleobaseCustomComponentsProvider from './providers/NucleobaseCustomComponentsProvider/NucleobaseCustomComponentsProvider.esm.js';
import NucleobaseProvider from './providers/NucleobaseProvider/NucleobaseProvider.esm.js';
import ToggleNucleobaseProvider from './providers/ToggleProvider/ToggleProvider.esm.js';
import VideoNucleobaseProvider from './providers/VideoProvider/VideoProvider.esm.js';

/**
 * Providers order is critical - do not edit unless you are aware of the Provider Ordering Rules below
 * Provider Ordering Rules:
 * 1. i18n related providers should be rendered first
 * Note: Some providers may behave differently based on provided country code (for example analytics)
 *
 * 2. Third Party providers should be rendered after i18n providers
 * Note: Mainly because they do not depend on neither other third party providers nor Invitae's React Providers.
 *       Those also tend to need "visibility" as soon as possible (like analytic providers)
 * - a) Third Party providers are independent - order of those doesn't matter
 *
 * 2. Invitae's internal providers should be after Third Party providers
 * - a) Invitae's providers are independent of each other - order of those doesn't matter
 *
 * 3. Contentful providers should be before Nucleobase providers
 * Note: Nucleobase depends on Contentful.
 * - a) ContentfulProvider should be ordered at top of Contentful providers. Rest doesn't matter.
 *
 * 4. Nucleobase providers should be after Contentful providers.
 * - a) Nucleobase providers are not rendered unless ContentfulProvider is present
 * - b) NucleobaseProvider should be ordered at top of Nucleobase providers. Rest doesn't matter.
 *
 * 5. Navigation providers should be after Contentful & Nucleobase providers
 * Note: Navigation content is powered by Contentful and components are defined in Nucleobase
 */
var providers = [
    /** i18n */
    LocationProvider,
    CountryLocationProvider,
    /** User authentication */
    UserAuthProvider,
    /** Third Party providers */
    ToggleNucleobaseProvider,
    PageAnalyticsProvider,
    /** Invitae's providers */
    AnimationProvider,
    BrowserProvider,
    DimensionsProvider,
    /** Contentful providers */
    ContentfulProvider,
    ContentfulPreviewProvider,
    GlobalTextCopyProvider,
    GlobalActionsProvider,
    /** Nucleobase providers */
    NucleobaseProvider,
    NucleobaseCustomComponentsProvider,
    /** Navigation providers */
    NavigationProvider,
    CartProvider,
    /** Other Nucleobase/Contentful component providers */
    ComponentBlockProvider,
    VideoNucleobaseProvider,
    /** Children/contentful page rendering - rendered at the bottom (as last) */
    BaseComponentProvider,
];
var AppProvider = combineProviders.apply(void 0, __spreadArray([], __read(providers), false));

export { AppProvider as default };
//# sourceMappingURL=AppProvider.esm.js.map
